import React from 'react';
import {Button} from 'react-bootstrap';
import TranslationLabel from '../../src/components/TranslationLabel';
import '../styles/Button/Button.scss';

function Custom_Button({
  className,
  onClick,
  src,
  alt,
  buttonLabel,
  count,
  backgroundColor,
  text_align,
  children,
}) {
  return (
    <Button
      className={`d-flex justify-content-center justify-content-lg-between align-items-center px-3 py-2 ${className} ${
        backgroundColor ? 'custom-button2' : 'custom-button1'
      }`}
      onClick={onClick}
    >
      <div className="d-flex align-items-center">
        {src && <img height={20} width={20} src={src} alt={alt} />}
        <span className={`pl-2 text-break ${text_align}`}>
          {buttonLabel && <TranslationLabel id={buttonLabel} defaultValue="Needs Label" />}
          {children}
        </span>
      </div>
      {count && <div className="filter-counter ml-4 d-inline-block">{count}</div>}
    </Button>
  );
}

export default Custom_Button;
